import { createFileRoute } from '@tanstack/react-router';
import { useCallback } from 'react';
import { Button } from '@fiado/react-kit';
import { ScopedAuditTable, type AuditRow } from '../../components/scoped/ScopedAuditTable';
import { PLATFORM_AUDIT_DESCRIPTOR } from '../../components/scoped/scopeDescriptors';
import { usePlatformAuditNames } from '../../hooks/usePlatformAuditNames';
import { platformAuditActorLabel, platformAuditTargetLabel } from '../../lib/platformAuditLabels';

/** Auditoría de plataforma: el motor compartido con actor y recurso resueltos a nombres. */
function PlatformAuditPage() {
    const { maps, adminOptions, hasError, retry } = usePlatformAuditNames();

    const resolveActor = useCallback(
        (row: AuditRow): string => platformAuditActorLabel(row, maps.admins),
        [maps.admins],
    );
    const resolveTarget = useCallback(
        (row: AuditRow): string => platformAuditTargetLabel(row, maps),
        [maps],
    );

    return (
        <div className="space-y-3">
            {hasError && (
                <div
                    role="alert"
                    className="flex items-center justify-between gap-3 rounded-md border border-destructive/40 bg-destructive/5 px-4 py-3 text-sm text-destructive"
                >
                    <span>
                        No pudimos cargar algunos nombres; ciertos registros se muestran sin nombre.
                    </span>
                    <Button variant="outline" size="sm" onClick={retry}>
                        Reintentar
                    </Button>
                </div>
            )}
            <ScopedAuditTable
                descriptor={PLATFORM_AUDIT_DESCRIPTOR}
                resolveActor={resolveActor}
                resolveTarget={resolveTarget}
                actorOptions={adminOptions}
            />
        </div>
    );
}

export const Route = createFileRoute('/_authenticated/_layout/platform/audit')({
    component: PlatformAuditPage,
});
